import React, {useEffect, useState} from "react";
import {CSVLink} from "react-csv";
import {Button, Table, TableBody, TableCell, TableContainer, TableHead, TableRow} from "@mui/material";
import LandingCommunityLogsUpdate from "./Logs/LandingCommunityLogsUpdate"; // Import your edit component
import FunctionsData from "../../Functions/FunctionsData";

/*
    Show table
    @param {array} data
    @param {string} selMonth
    @param {function} setLoading (optional) - If you need to reload data after editing
*/
export default function VetsReportingShowTable({data, selMonth, setLoading,loading}) {

    const [d,setD] = useState(data || []);
    const [csv,setCSV] = useState([]);
    const [amount,setAmount] = useState(0);
    const [amountInvoiced,setAmountInvoiced] = useState(0);
    const [countInvoiced,setCountInvoiced] = useState(0);

    // State for editing functionality
    const [showLogsManage, setShowLogsManage] = useState(false);
    const [currentRow, setCurrentRow] = useState(null);

    const [row, setRow] = useState([]);
    const [googlePlace, setGooglePlace] = useState([]);
    const [animal, setAnimal] = useState([]);
    const [microchips, setMicrochips] = useState([]);

    useEffect(() => {

        fetch(FunctionsData.getApiUrl('/api/orders/microchips/all'), {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'token': localStorage.vTkn
            }
        })
            .then((res) => res.json())
            .then((d) => {
                let m = d.data;
                let mc = [];
                for (let x in m) {
                    mc.push(m[x]['a_microchip_number'])
                }
                setMicrochips(mc);
            });

    }, [])

    useEffect(() => {
        setD(data);
    }, [data]);

    useEffect(() => {
        updateData();
    }, [d]);

    useEffect(() => {

        // if (currentRow.is_redeemed > 0) {
        //     let x = currentRow;
        //     x.a_microchip_number = '';
        //     x.a_name = '';
        //     x.a_gender = '';
        //     x.a_age = '';
        //     x.a_weight = '';
        //     x.a_color_primary = '';
        //     x.a_color_secondary = '';
        //     x.a_surgery_amount = 0.0;
        //     x.a_type_surgery = '';
        //     x.a_is_pregnant = 0;
        //     x.a_was_pregnant = 0;
        //     x.vet_id = 0;
        //     x.sponsor_id = 0;
        //     x.sponsor_applicant_cost = 0;
        //     setRow(x);
        // } else {
            setRow(currentRow);
            // setSurgeryTypeFn(currentRow.a_gender);
        // }
    }, [currentRow]);

    function updateData() {
        let c = [];
        let amt = 0;
        let amt_invoiced = 0;
        let count_invoiced = 0;
        for(let x in d) {
            if (!d.hasOwnProperty(x)) continue;
            if(d[x]['invoiced'] > 0) {
                amt_invoiced += d[x]['nominal_value'];
                count_invoiced += 1;
            }
            amt += d[x]['nominal_value'];
            c.push({
                "Voucher": parseInt(d[x]['voucher_nr']),
                "Campaign": d[x]['campaign_name'],
                "Microchip":"#"+ d[x]['a_microchip_number'],
                "Microchip added":
                    (d[x]['microchip_added'] < 0 || (d[x]['microchip_added'] === 0 && (d[x]['a_microchip_number'] === null || d[x]['microchip_reason_why_not'] !== ''))) ?
                        'not chipped' :
                        (d[x]['microchip_added'] > 0) ? "new" :"existing",
                "Amount": d[x]['nominal_value'],
                "Invoiced": d[x]['invoiced_id'],
                "Redeemed_On": new Date(d[x]['transaction_date']).toLocaleDateString('en-NZ'),
                "Vet": d[x]['supplier_business_name'],
                "Procedure": d[x]['a_type_surgery'],
                "Sex": d[x]['a_gender'],
                "Paid/Unpaid": d[x]['voucher_paid_status']
            });
        }

        setCountInvoiced(count_invoiced);
        setAmountInvoiced(amt_invoiced);
        setAmount(amt);
        setCSV(c);
    }

    if(selMonth === '') return "No months selected";

    return (
        <div style={{marginTop:20}}>
            <p>
                {csv.length > 0 ?
                    <CSVLink data={csv}>
                        <Button variant={"contained"}>
                            Download your redeemed voucher records as CSV file to open in Excel
                        </Button>
                    </CSVLink>
                    : null}
            </p>
            <div className={"vet-summary-box"}>
                <h1 style={{textDecoration:'underline', marginBottom:20}}>Summary</h1>
                <h4>Vouchers: {data.length} (To be invoiced: {countInvoiced})</h4>
                <h4>Total amount: ${amount.toFixed(2)} (To be invoiced: ${amountInvoiced.toFixed(2)})</h4>
            </div>
            <TableContainer>
                <Table sx={{ minWidth: 680 }} aria-label="simple table">
                    <TableHead>
                        <TableRow>
                            <TableCell>Voucher#</TableCell>
                            <TableCell></TableCell>
                            <TableCell>Issued on</TableCell>
                            <TableCell>Campaign</TableCell>
                            <TableCell>Amount</TableCell>
                            <TableCell>Procedure</TableCell>
                            <TableCell>Redeemed on</TableCell>
                            <TableCell>Microchip added</TableCell>
                            <TableCell>Animal</TableCell>
                            <TableCell>Age</TableCell>
                            <TableCell>Sex</TableCell>
                            <TableCell>Paid/Unpaid</TableCell>
                            {/* Actions column removed */}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {data.map((row, idx) => (
                            <TableRow
                                key={idx}
                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                            >
                                <TableCell>{row.voucher_nr}</TableCell>
                                <TableCell>
                                    {row.invoiced > 0 ? (
                                        <div style={{background:'lightgrey', padding:10, borderRadius:5, fontSize:'0.8em'}}>
                                            <span style={{whiteSpace:'nowrap'}}>To be invoiced</span><br />
                                            <span style={{whiteSpace:'nowrap'}}>Schedule ID: {row.invoiced_schedule_id}</span>
                                        </div>
                                    ) : (
                                        <a
                                            href="#"
                                            onClick={(e) => {
                                                e.preventDefault();
                                                setCurrentRow(row);
                                                setShowLogsManage(true);
                                            }}
                                        >
                                            Edit data
                                        </a>
                                    )}
                                </TableCell>
                                <TableCell>{new Date(row.created_at).toLocaleDateString('en-NZ')}</TableCell>
                                <TableCell>{row.campaign_name}</TableCell>
                                <TableCell>${row.a_surgery_amount.toFixed(2)}</TableCell>
                                <TableCell>{row.a_type_surgery}</TableCell>
                                <TableCell>{new Date(row.transaction_date).toLocaleDateString('en-NZ')}</TableCell>
                                <TableCell>
                                    {(row.microchip_added > -1) ?
                                        <span>#{row.animal_chip_number} {(row.microchip_added > 0) ? "(new)" : "(existing)"}</span> :
                                        "No microchip"
                                    }
                                </TableCell>
                                <TableCell>{row.a_type}</TableCell>
                                <TableCell>{row.a_age}</TableCell>
                                <TableCell>{row.a_gender}</TableCell>
                                <TableCell>
                                    <span style={{ color: (row.voucher_paid_status || '').toLowerCase() === 'paid' ? 'green' : 'red' }}>
                                        {(row.voucher_paid_status || 'unpaid').charAt(0).toUpperCase() + (row.voucher_paid_status || 'unpaid').slice(1).toLowerCase()}
                                    </span>
                                    </TableCell>
                                </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>

            {showLogsManage && currentRow && (
                <LandingCommunityLogsUpdate
                    key={currentRow.voucher_nr}
                    open={showLogsManage}
                    setOpen={setShowLogsManage}
                    row={currentRow}
                    mode={"redeemed"} // or another mode if needed
                    loading = {loading}
                    setLoading={setLoading}
                    animal={animal}
                    setAnimal={setAnimal}
                    microchips={microchips}
                    setRow={setRow} // If you need to trigger reload after saving
                />
            )}
        </div>
    )
}
